import { render, staticRenderFns } from "./GameWon.vue?vue&type=template&id=2fef7ae0&scoped=true&"
import script from "./GameWon.vue?vue&type=script&lang=js&"
export * from "./GameWon.vue?vue&type=script&lang=js&"
import style0 from "./GameWon.vue?vue&type=style&index=0&id=2fef7ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef7ae0",
  null
  
)

export default component.exports